import { CDN_URL } from "@/constants/cdn";
import { SDKConfiguration } from "@/inference/setup/config";
import { UISDK } from "@/ui-sdk";

const BACKEND_URL =
  "https://helium-backend-helium-service-pr-38.up.railway.app";
// const BACKEND_URL = SDKConfiguration.API_ENDPOINT;
let isFestivalCollectionsRendered = false;

export type ActiveHoliday = {
  name: string;
  description: string;
  eventStart: string; // Format: DD-MM-YYYY
  eventEnd: string; // Format: DD-MM-YYYY
};

export async function handleFestivalCollections(
  element: HTMLElement,
  sdk: UISDK,
) {
  // Check if already rendered before setting up the interval
  if (isFestivalCollectionsRendered) {
    console.info("Festival collections already rendered, skipping.");
    return;
  }

  let intervalId: NodeJS.Timeout | null = null;

  const renderCollection = async () => {
    await new Promise((res) => {
      const interval = setInterval(() => {
        const attributes = window.helium.attributes.persona.primary;
        const keys = Object.keys(attributes);
        if (
          keys.length > 35 &&
          attributes.location &&
          attributes.location?.city
        ) {
          clearInterval(interval);
          res(null);
        }
      }, 50);
    });

    console.info({ intervalId, isFestivalCollectionsRendered });
    if (isFestivalCollectionsRendered) {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
      return;
    }
    console.log("renderssssing");
    const orgId = window?.helium?.brandData?.orgId;

    const devRegion = new URLSearchParams(window.location.search).get(
      "dev_region",
    );

    const region =
      devRegion ||
      window?.helium?.attributes?.persona?.secondary?.associatedRegion ||
      "Northern Plains";

    const regionsHoliday = CDN_URL + "/global/regions/active-holidays.json";
    const collectionName = window.location.pathname.split("/").at(-1);
    const collectionUrl = `${CDN_URL}/${orgId}/collection${window.filterableCollections == true ? "/with-filter" : ""}/${collectionName}/sub-collections.json`;
    console.info(
      `${CDN_URL}/${orgId}/collections${window.filterableCollections == true ? "/with-filter" : ""}/${collectionName}/sub-collections.json`,
      "asdds",
    );
    try {
      const collectionData = await fetch(collectionUrl).then((r) => r.json());
      const activeHolidayData: Record<string, ActiveHoliday> = await fetch(
        regionsHoliday,
      ).then((r) => r.json());
      const currentHoliday = activeHolidayData[region] as ActiveHoliday;
      sdk.renderFestivalCollection(element, collectionData, currentHoliday);
      isFestivalCollectionsRendered = true;
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    } catch (error) {
      console.error("Error fetching collections:", error);
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    }
  };

  await renderCollection();
  if (!isFestivalCollectionsRendered) {
    intervalId = setInterval(renderCollection, 500);
  }
}
